export default __webpack_public_path__ + "static/media/mint-your-pets.292aa25a.svg";